(function () {
  'use strict';

  const DEBOUNCE_MS = 400;

  document.querySelectorAll('[data-search-section]').forEach(init);

  function init(section) {
    const sectionId = section.dataset.sectionId;
    let abortController = null;
    let debounceTimer = null;

    async function applyFromUrl(url, { append = false } = {}) {
  if (abortController) {
    try { abortController.abort(); } catch (e) {}
  }
  abortController = new AbortController();
  const signal = abortController.signal;

  section.setAttribute('aria-busy', 'true');
  const grid = section.querySelector('[data-search-grid]');
  if (grid && !append) grid.classList.add('is-loading');

  // Fetch the full page — Shopify's Section Rendering API doesn't work
  // with /search, but the full page contains our #search-results block
  // which DOMParser can extract.
  const fetchUrl = new URL(url, window.location.origin);
  // NOTE: no section_id param — /search doesn't support it.

  try {
    const res = await fetch(fetchUrl.toString(), {
      signal,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (signal.aborted) return;
    if (!res.ok) throw new Error('HTTP ' + res.status);
    const html = await res.text();
    if (signal.aborted) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newRoot = doc.querySelector(`#${sectionId}`);
    if (!newRoot) {
      window.location.href = url;
      return;
    }

    if (append) {
      const newGrid = newRoot.querySelector('[data-search-grid]');
      const newPagination = newRoot.querySelector('.search-pagination');
      const oldPagination = section.querySelector('.search-pagination');
      if (newGrid && grid) {
        Array.from(newGrid.children).forEach((child) => grid.appendChild(child));
      }
      if (oldPagination) oldPagination.remove();
      if (newPagination) section.querySelector('.search-main').appendChild(newPagination);
    } else {
      section.innerHTML = newRoot.innerHTML;
    }

    window.history.pushState({ searchFiltered: true }, '', url);

    if (!append) {
      const anchor = section.querySelector('.search-toolbar') || section;
      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    bind();
  } catch (err) {
    if (err.name === 'AbortError' || err.name === 'DOMException' || signal.aborted) return;
    console.error('[search-filters]', err);
    window.location.href = url;
  } finally {
    section.setAttribute('aria-busy', 'false');
    if (grid) grid.classList.remove('is-loading');
  }
}

    function urlFromForm() {
      const form = section.querySelector('[data-search-filter-form]');
      const sort = section.querySelector('[data-search-sort]');
      const params = new URLSearchParams();

      // Preserve the search query
      const terms = section.dataset.searchTerms || '';
      params.set('q', terms);

      if (form) {
        form.querySelectorAll('[data-filter-input]').forEach((input) => {
          if (input.type === 'checkbox' && !input.checked) return;
          if (input.value === '') return;
          params.append(input.name, input.value);
        });
      }
      if (sort && sort.value && sort.value !== 'relevance') {
        params.set('sort_by', sort.value);
      }
      return `/search?${params.toString()}`;
    }

    function bind() {
      const form = section.querySelector('[data-search-filter-form]');
      const sort = section.querySelector('[data-search-sort]');
      const loadMore = section.querySelector('[data-search-load-more]');
      const filterToggle = section.querySelector('[data-search-filters-toggle]');
      const filtersEl = section.querySelector('[data-search-filters]');
      const filtersClose = section.querySelector('[data-search-filters-close]');
      const filtersApply = section.querySelector('[data-search-filters-apply]');

      if (form) {
        form.addEventListener('submit', (e) => e.preventDefault());
        form.addEventListener('change', (e) => {
          if (e.target.matches('[data-filter-debounced]')) return;
          applyFromUrl(urlFromForm());
        });
        form.addEventListener('input', (e) => {
          if (!e.target.matches('[data-filter-debounced]')) return;
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => applyFromUrl(urlFromForm()), DEBOUNCE_MS);
        });
      }

      if (sort) {
        sort.addEventListener('change', () => applyFromUrl(urlFromForm()));
      }

      if (loadMore) {
        loadMore.addEventListener('click', (e) => {
          e.preventDefault();
          applyFromUrl(loadMore.dataset.nextUrl, { append: true });
        });
      }

      section.querySelectorAll('[data-filter-remove]').forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          applyFromUrl(link.href);
        });
      });

      // Mobile drawer controls
      if (filterToggle && filtersEl) {
        filterToggle.addEventListener('click', () => {
          filtersEl.classList.add('is-open');
          document.body.classList.add('search-filters-open');
        });
      }
      if (filtersClose && filtersEl) {
        filtersClose.addEventListener('click', () => {
          filtersEl.classList.remove('is-open');
          document.body.classList.remove('search-filters-open');
        });
      }
      if (filtersApply && filtersEl) {
        filtersApply.addEventListener('click', () => {
          filtersEl.classList.remove('is-open');
          document.body.classList.remove('search-filters-open');
        });
      }
    }

    window.addEventListener('popstate', () => {
      applyFromUrl(window.location.href);
    });

    bind();
  }
})();